export const campaignTypes = {
  CUSTOM: 'custom',
  GROUP: 'group',
  LOCATION: 'location',
  LOCATIONs: 'locations',
  VENDOR: 'vendor'
}

export default {
  CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
  LIST_CAMPAIGN: 'LIST_CAMPAIGN',
  RETRIEVE_CAMPAIGN: 'RETRIEVE_CAMPAIGN',
  UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
  DESTROY_CAMPAIGN: 'DESTROY_CAMPAIGN',
  CLEAR_CAMPAIGN: 'CLEAR_CAMPAIGN',
  RECEIVE_MANUAL_QUERIES: 'RECEIVE_MANUAL_QUERIES'
};



/** WEBPACK FOOTER **
 ** ./src/constants/campaign.js
 **/